import { t } from '../../i18n/init.js';
import { setText } from '../dom-helpers.js';

export interface ShareToastOptions {
  success: boolean;
  message?: string | undefined;
  dismissMs?: number | undefined;
}

// Mounts a transient toast that announces share success or failure. Returns
// a manual cleanup so the renderer can dismiss any prior toast before
// showing a new one.
export function showShareToast(root: HTMLElement, opts: ShareToastOptions): () => void {
  const dismissMs = opts.dismissMs ?? 3000;

  const toast = document.createElement('div');
  toast.classList.add('viewer-ui-interactive');
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.style.cssText = opts.success
    ? 'position:fixed;top:1rem;left:50%;transform:translateX(-50%);background:rgba(20,83,45,0.95);color:#dcfce7;padding:0.5rem 0.875rem;border-radius:0.375rem;font-family:system-ui,sans-serif;font-size:0.875rem;z-index:13;pointer-events:auto;max-width:24rem'
    : 'position:fixed;top:1rem;left:50%;transform:translateX(-50%);background:rgba(127,29,29,0.95);color:#fee2e2;padding:0.5rem 0.875rem;border-radius:0.375rem;font-family:system-ui,sans-serif;font-size:0.875rem;z-index:13;pointer-events:auto;max-width:24rem';

  setText(
    toast,
    opts.success
      ? t('viewer.share.copied')
      : opts.message
        ? t('viewer.share.failed_detail', { message: opts.message })
        : t('viewer.share.failed'),
  );

  root.appendChild(toast);

  const timer = setTimeout(() => toast.remove(), dismissMs);

  return () => {
    clearTimeout(timer);
    toast.remove();
  };
}
